import React from 'react';
import Button from "react-bootstrap/Button";
import CustomModal, {CustomModalProps} from "../app/common/components/modal/CustomModal";

interface Props extends Omit<CustomModalProps, 'footer' | 'body'> {
  disable?: boolean;
  submitLabel?: string;
  onSubmit: () => void;
  children: JSX.Element;
}

function FormModal(props: Props): JSX.Element {
  return (
    <CustomModal
      {...props}
      body={props.children}
      footer={
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              props.onHide();
            }}
          >
            Annuler
          </Button>
          <Button
            disabled={props.disable}
            variant="celeste-primary"
            size="sm"
            onClick={props.onSubmit}
          >
            {props.submitLabel ?? 'Enregistrer'}
          </Button>
        </>
      }
    />
  );
}

export default FormModal;